export const types = {
  //Types Auth
  login: '[auth] login',
  logout: '[auth] logout',

  //Types UI
  uiSetError: '[UI] Set Error',
  uiRemoveError: '[UI] Remove Error',
  uiStartLoading: '[UI] Start Loading',
  uiFinishLoading: '[UI] Finish Loading',

  //Types Notes
  notesAddNew: '[Notes] New note',
  notesActive: '[Notes] Set active note',
  notesLoad: '[Notes] Load note',
  notesUpdated: '[Notes] Updated note',
  notesFileUrl: '[Notes] Updated image url',
  notesDelete: '[Notes] Delete notes',
  notesLogoutCleaning: '[Notes] Logout Cleaning'
};